import { inject, Injectable } from '@angular/core';
import { ApiService, BaseCommandRepository } from '@okcargo-apps/shared-infrastructure';
import {
  AddPushTokenCommand,
  AddPushTokenCommandHandler,
  CreateOrUpdateCollaboratorRoutesPreferencesCommand,
  CreateOrUpdateCollaboratorRoutesPreferencesCommandHandler,
  UpdateCollaboratorQuestionairCommand,
  UpdateCollaboratorQuestionairCommandHandler,
  UpdateContactMailingPreferencesCommand,
  UpdateContactMailingPreferencesCommandHandler,
  UpdateMailingPreferencesCommand,
  UpdateMailingPreferencesCommandHandler,
  UpdateUserPasswordCommand,
  UpdateUserPasswordCommandHandler,
} from '@okcargo/command-processor';
import { catchError, from, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountCommandService {
  private readonly apiService = inject(ApiService);

  private readonly _changePasswordRequestUrl = '/service/command-processor/api/users/request-password-reset';
  private readonly _changePasswordConfirmUrl = '/service/command-processor/api/users/password-reset';

  private readonly updateMailingPreferencesCommandHandler: UpdateMailingPreferencesCommandHandler;
  private readonly updateContactMailingPreferencesCommandHandler: UpdateContactMailingPreferencesCommandHandler;
  private readonly updateCollaboratorQuestionairCommandHandler: UpdateCollaboratorQuestionairCommandHandler;
  private readonly createOrUpdateCollaboratorRoutesPreferencesCommandHandler: CreateOrUpdateCollaboratorRoutesPreferencesCommandHandler;
  private readonly addPushTokenCommandHandler: AddPushTokenCommandHandler;
  private readonly updateUserPasswordCommandHandler: UpdateUserPasswordCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.updateMailingPreferencesCommandHandler = new UpdateMailingPreferencesCommandHandler(commandRepository);
    this.updateContactMailingPreferencesCommandHandler = new UpdateContactMailingPreferencesCommandHandler(
      commandRepository,
    );
    this.updateCollaboratorQuestionairCommandHandler = new UpdateCollaboratorQuestionairCommandHandler(
      commandRepository,
    );
    this.createOrUpdateCollaboratorRoutesPreferencesCommandHandler =
      new CreateOrUpdateCollaboratorRoutesPreferencesCommandHandler(commandRepository);
    this.addPushTokenCommandHandler = new AddPushTokenCommandHandler(commandRepository);
    this.updateUserPasswordCommandHandler = new UpdateUserPasswordCommandHandler(commandRepository);
  }

  // TODO
  public async saveLang(lang: string): Promise<void> {
    // if (!this.apiService.newEndpointExists)
    //   firstValueFrom(
    //     this.apiService.post(
    //       this._oldChangeLaguageUrl,
    //       {
    //         langKey: lang,
    //       },
    //       { observe: 'response' },
    //     ),
    //   );
  }

  public changePasswordRequest(email: string): Observable<void> {
    return this.apiService
      .post(
        this._changePasswordRequestUrl,
        {
          username: email,
        },
        { observe: 'response' },
        false,
      )
      .pipe(
        map(() => void 0),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }

  public changePasswordConfirm(email: string, newPassword: string, key: string): Observable<void> {
    return this.apiService
      .post(
        this._changePasswordConfirmUrl,
        {
          username: email,
          password: newPassword,
          code: key,
        },
        { observe: 'response' },
        false,
      )
      .pipe(
        map(() => void 0),
        catchError((error) => {
          return throwError(() => error);
        }),
      );
    // TODO new changepasswordrequest
  }

  public changePassword(currentPassword: string, newPassword: string): Observable<void> {
    const command = {
      password: currentPassword,
      newPassword: newPassword,
    } as UpdateUserPasswordCommand;
    return from(this.updateUserPasswordCommandHandler.handle(command));
  }

  public updateMailingPreferences(command: UpdateMailingPreferencesCommand): Promise<void> {
    return this.updateMailingPreferencesCommandHandler.handle(command);
  }

  public updateContactMailingPreferences(command: UpdateContactMailingPreferencesCommand): Promise<void> {
    return this.updateContactMailingPreferencesCommandHandler.handle(command);
  }

  public updateCollaboratorQuestionair(command: UpdateCollaboratorQuestionairCommand): Promise<void> {
    return this.updateCollaboratorQuestionairCommandHandler.handle(command);
  }

  public updateCollaboratorRoutesPreferences(
    command: CreateOrUpdateCollaboratorRoutesPreferencesCommand,
  ): Promise<void> {
    return this.createOrUpdateCollaboratorRoutesPreferencesCommandHandler.handle(command);
  }

  public addPushTokenCommand(command: AddPushTokenCommand): Promise<void> {
    return this.addPushTokenCommandHandler.handle(command);
  }
}
